"use client";
import { Box, Flex, Heading } from "@chakra-ui/react";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { RichTextContent } from "@graphcms/rich-text-types";
import { SectionTemplate } from "components/individuals/blocks";
import { customRichText } from "components/individuals/mdx-components";

export interface IndustriesProductPitchSectionProps {
  title: string;
  titleColor: string;
  subtitle: string;
  subtitleColor: string;
  content: {
    raw: RichTextContent;
  };
  bg: string;
  color: string;
  from?: string;
}

export const IndustriesProductPitchSection = ({
  title,
  titleColor,
  subtitle,
  subtitleColor,
  content,
  bg,
  color,
  from,
}: IndustriesProductPitchSectionProps) => {
  return (
    <SectionTemplate bg={bg} borderRadius={0}>
      <Flex
        maxW="1215px"
        flexDir={{
          base: "column",
          lg: "row",
        }}
        gap={10}
        justify={"space-between"}
      >
        <Box
          w={{
            lg: "70%",
          }}
        >
          <Flex align={"center"}>
            <Heading
              as={"h3"}
              fontSize={{
                base: 16,
                md: 18,
                lg: 20,
              }}
              fontWeight="bold"
              color={subtitleColor}
              mb={{
                base: 1,
                lg: 3,
              }}
              mr={1}
              position="relative"
            >
              {subtitle}
            </Heading>
            <Box
              bgColor={subtitleColor}
              flex="1"
              h={{
                base: "2px",
                lg: "3px",
              }}
              mb={{
                base: 1,
                lg: 3,
              }}
            />
          </Flex>
          <Heading
            as="h2"
            lineHeight={1.2}
            color={titleColor}
            fontSize={{
              base: 26,
              md: 34,
              lg: 38,
              xl: 45,
            }}
            fontWeight={"bold"}
          >
            {title}
          </Heading>
        </Box>
        <Box
          color={color}
          w={{
            lg: "50%",
          }}
          mt={{
            base: "-9",
            lg: 0,
          }}
          fontSize={{
            base: 14,
            md: 16,
            lg: 17,
            xl: 18,
          }}
        >
          <RichText
            content={content.raw}
            renderers={customRichText(color, 5)}
          />
        </Box>
      </Flex>
    </SectionTemplate>
  );
};
